export default "__VITE_ASSET__DoBkPWMk__"